export const jobtypeConstants = [
  '営業',
  'マーケティング・企画',
  '事務・管理',
  '経営企画・事業企画',
  'クリエイティブ',
  'IT系（その他）',
  '販売・サービス',
  'コンサルタント・士業',
  '研究開発',
  '技術職（理系）',
  '専門職（金融）',
  '専門職（不動産・建設）',
  '購買・物流・生産管理',
  '秘書・アシスタント',
  '専門職（医療）',
];
